import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowUpRight, Sparkles } from 'lucide-react';

const HeroSection = () => {
  const scrollToServices = () => {
    const element = document.querySelector('#services');
    if (element) element.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section id="home" className="relative z-10 max-w-6xl mx-auto px-6 pt-20 pb-24 grid lg:grid-cols-[1.15fr_1fr] gap-14 items-center">
      <div>
        <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-white/60 backdrop-blur-lg border border-white/80 text-xs text-[#5a4a3a] mb-8 shadow-sm">
          <Sparkles className="w-3.5 h-3.5 text-[#c9a962]" />
          <span>A boutique commodity brokerage · Est. 2015</span>
        </div>
        <h1 className="text-5xl md:text-6xl lg:text-7xl font-semibold leading-[1] tracking-[-0.035em] text-[#2a2420] mb-6">
          Physical trade,<br />
          <span className="font-serif-display italic font-medium text-[#8b5a2b]">beautifully</span> done.
        </h1>
        <p className="text-lg text-[#5a4a3a] font-light max-w-xl leading-relaxed mb-10 tracking-[-0.005em]">
          From Territory earth to Singapore port, GSD moves the commodities that build the modern world. Supply chain management across energy, raw materials, technology metals, and base metals.
        </p>
        <div className="flex items-center gap-3 flex-wrap">
          <button
            onClick={scrollToServices}
            className="group bg-[#2a2420] hover:bg-[#1a1410] text-[#fbf8f3] font-medium px-7 py-3.5 rounded-full transition-all hover:scale-[1.02] active:scale-[0.98] shadow-[0_8px_24px_-8px_rgba(42,36,32,0.4)] flex items-center gap-2"
          >
            Explore our services
            <ArrowUpRight className="w-4 h-4 group-hover:translate-x-0.5 group-hover:-translate-y-0.5 transition-transform" />
          </button>
          <Link
            to="/#contact"
            className="bg-white/60 backdrop-blur-lg border border-white/80 hover:bg-white/80 text-[#2a2420] font-medium px-7 py-3.5 rounded-full transition-all hover:scale-[1.02] active:scale-[0.98]"
          >
            Engage the desk
          </Link>
        </div>
      </div>

      {/* Photography framed in glass card */}
      <div className="relative">
        <div className="absolute -inset-6 bg-gradient-to-br from-amber-300/40 via-rose-200/30 to-transparent blur-3xl -z-10" />
        <div className="relative rounded-[2rem] overflow-hidden border border-white/80 shadow-[0_24px_64px_-16px_rgba(80,50,20,0.25)] bg-white/40 backdrop-blur-xl p-2">
          <div
            className="aspect-[4/5] rounded-[1.6rem] bg-cover bg-center"
            style={{ backgroundImage: 'url(/images/nt-hero.png)' }}
          />
          <div className="absolute bottom-6 left-6 px-4 py-2.5 rounded-full bg-white/80 backdrop-blur-xl border border-white text-xs shadow-lg">
            <span className="font-medium text-[#2a2420]">Northern Territory</span>
            <span className="text-[#8b5a2b] mx-2">·</span>
            <span className="font-serif-display italic text-[#5a4a3a]">the source</span>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
